import Reflux from "reflux";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import UserNotification from "util/UserNotification";
import { singletonStore, singletonActions } from "logic/singleton";
export const InputTypesActions = singletonActions(
  "core.InputTypes",
  () => Reflux.createActions({
    list: { asyncResult: true },
    get: { asyncResult: true }
  })
);
export const InputTypesStore = singletonStore(
  "core.InputTypes",
  () => Reflux.createStore({
    listenables: [InputTypesActions],
    sourceUrl: "/system/inputs/types",
    inputTypes: void 0,
    inputDescriptions: void 0,
    init() {
      this.list();
    },
    getInitialState() {
      return { inputTypes: this.inputTypes, inputDescriptions: this.inputDescriptions };
    },
    list() {
      const promiseTypes = fetch("GET", qualifyUrl(this.sourceUrl));
      const promiseDescriptions = fetch("GET", qualifyUrl(`${this.sourceUrl}/all`));
      const promise = Promise.all([
        promiseTypes,
        promiseDescriptions
      ]);
      promise.then(
        ([typesResponse, descriptionsResponse]) => {
          this.inputTypes = typesResponse.types;
          this.inputDescriptions = descriptionsResponse;
          this.trigger(this.getInitialState());
        },
        (error) => {
          UserNotification.error(`Fetching Input Types failed with status: ${error}`, "Could not retrieve Inputs");
        }
      );
      InputTypesActions.list.promise(promise);
    },
    get(inputTypeId) {
      const promise = fetch("GET", qualifyUrl(`${this.sourceUrl}/${inputTypeId}`));
      promise.catch((error) => {
        UserNotification.error(
          `Fetching input ${inputTypeId} failed with status: ${error}`,
          "Could not retrieve input"
        );
      });
      InputTypesActions.get.promise(promise);
    }
  })
);
